import { ITextMapDrawing, TextMapDrawingAction } from './map-text-editor.types';
export const MAP_TEXT_EDITOR_SET_TEXT: string = 'MAP_TEXT_EDITOR_SET_TEXT';
export const MAP_TEXT_EDITOR_FINISH_EDIT: string =
	'MAP_TEXT_EDITOR_FINISH_EDIT';

export function mapTextEditorSetText(
	drawing?: ITextMapDrawing
): TextMapDrawingAction {
	return { type: MAP_TEXT_EDITOR_SET_TEXT, payload: drawing };
}

export function mapTextEditorFinishEdit(): TextMapDrawingAction {
	return { type: MAP_TEXT_EDITOR_FINISH_EDIT };
}
